<template>
  <div style="position: relative">
    <img
      :src="'data:image/png;base64,' + imageData"
      ref="theImage"
      :class="{ toBeMeasured: !imageReady, disabled: disabled }"
      :height="imageHeight"
      :width="imageWidth"
      @click.prevent="setOffset"
      draggable="false"
    />
    <div
      ref="targetPoint"
      id="targetPoint"
      v-if="targetPoint.show"
      :style="{
        top: targetPoint.pos.y + 'px',
        left: targetPoint.pos.x + 'px'
      }"
      :class="{ 'cross-hairs': !targetPoint.icon }"
    >
      {{ targetPoint.icon }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
img {
  cursor: crosshair;
  &.disabled {
    cursor: default;
  }
  opacity: 0.45;

  // Initially place image outside flow, so we can measure its dimensions before putting
  // it inside the flow with fixed dimensions
  &.toBeMeasured {
    position: absolute;
    visibility: hidden;
    pointer-events: none;
  }
}

#targetPoint {
  color: red;
  font-size: 2em;
  pointer-events: none;
  position: absolute;

  &.cross-hairs {
    transform: translate(-10px, -10px);
    border: 2px solid red;
    border-radius: 10px;
    height: 20px;
    width: 20px;

    &::before {
      content: '';
      transform: translate(3px, 3px);
      border: 2px solid red;
      border-radius: 5px;
      height: 10px;
      width: 10px;
      display: block;
    }
  }
}
</style>

<script>
// @flow
export default {
  name: 'image-offsetter',
  props: {
    imageData: String,
    offsetX: Number,
    offsetY: Number,
    disabled: Boolean
  },

  data() {
    return {
      imageReady: false,
      imageHeight: 'auto',
      imageWidth: 'auto',
      debouncedShowImage: _.debounce(() => this.showImage(), 500)
    }
  },

  computed: {
    targetPoint() {
      const constraints = this.imageReady
        ? { h: this.imageHeight, w: this.imageWidth }
        : { h: 1000, w: 1000 }

      let icon = '' // Cross hairs are done in css
      if (this.offsetX > constraints.w) {
        icon = '→'
      } else if (this.offsetX < 0) {
        icon = '←'
      } else if (this.offsetY > constraints.h) {
        icon = '↓'
      } else if (this.offsetY < 0) {
        icon = '↑'
      }

      return {
        show: this.offsetY && this.offsetX,
        icon: icon,
        pos: {
          x: Math.max(Math.min(icon ? this.offsetX - 12 : this.offsetX, constraints.w), 0),
          y: Math.max(Math.min(icon ? this.offsetY - 9 : this.offsetY, constraints.h), 0)
        }
      }
    }
  },

  methods: {
    showImage() {
      var image = this.$refs.theImage
      if (image) {
        this.imageHeight = image.height
        this.imageWidth = image.width
        this.imageReady = true
      }
    },

    resetImage() {
      this.imageHeight = this.imageWidth = 'auto'
      this.imageReady = false
    },

    setOffset(evt) {
      if (this.disabled) return
      this.$emit('offsets', { x: evt.offsetX, y: evt.offsetY })
    }
  },

  mounted() {
    this.debouncedShowImage()
  },

  watch: {
    imageData(newData) {
      if (newData) {
        this.resetImage()
        this.debouncedShowImage()
      }
    }
  }
}
//
</script>
